import { useEffect, useState } from "react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { pushSupported, currentSubscription, enablePush, disablePush } from "@/lib/push";
import api from "@/lib/api";
import { toast } from "sonner";
import { BellRing } from "lucide-react";

export function PushToggle() {
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);
  const supported = pushSupported();
  useEffect(() => { if (supported) currentSubscription().then((s) => setOn(!!s)).catch(() => {}); }, [supported]);
  const toggle = async (v) => {
    setBusy(true);
    try {
      if (v) { await enablePush(); toast.success("Phone notifications enabled on this device"); } else { await disablePush(); toast.success("Notifications turned off on this device"); }
      setOn(v);
    } catch (e) { toast.error(/denied|permission/i.test(e.message || "") ? "Notifications were blocked or aren't available here. On iPhone, add RightPay to your Home Screen first; on desktop allow notifications for this site." : e.message || "Could not change notification setting"); } finally { setBusy(false); }
  };
  const test = async () => { try { await api.post("/push/test"); toast.success("Test notification sent"); } catch (e) { toast.error(e.response?.data?.detail || "Could not send test"); } };
  return (
    <div className="rounded-lg border p-3 space-y-2" data-testid="push-settings">
      <div className="flex items-center justify-between gap-3">
        <div><Label htmlFor="push-toggle" className="flex items-center gap-1.5"><BellRing className="w-4 h-4" /> Phone notifications</Label>
          <p className="text-xs text-muted-foreground">{supported ? "Payday reminders and payroll anomaly alerts as push notifications on this device." : "Not supported in this browser. On iPhone, add RightPay to your Home Screen first."}</p></div>
        <Switch id="push-toggle" data-testid="push-toggle" checked={on} disabled={!supported || busy} onCheckedChange={toggle} />
      </div>
      {on && <Button size="sm" variant="outline" data-testid="push-test" onClick={test}>Send test notification</Button>}
    </div>
  );
}
